export const SectionParagraph = ({ children }: { children: React.ReactNode }) => {
  return <p className="text-sm text-foreground">{children}</p>;
};
